"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var XHRRequestHandler = (function () {
    function XHRRequestHandler() {
    }
    XHRRequestHandler.prototype.getArrayBuffer = function (url, onSuccess, onError) {
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';
        request.onload = function () {
            if (request.status >= 400 && onError) {
                return onError("failed with: " + request.status + " " + request.statusText);
            }
            var arrayBuffer = request.response;
            var byteArray = new Uint8Array(arrayBuffer);
            onSuccess(client_lib_js_player_framework_utils_1.uintToDecodedXmlString(byteArray));
        };
        request.onerror = function () {
            if (onError) {
                onError("failed with: " + request.status + " " + request.statusText);
            }
        };
        request.send();
    };
    XHRRequestHandler.prototype.getXml = function (url, onSuccess, onError) {
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.onreadystatechange = function (response) {
            if (request.readyState !== XMLHttpRequest.DONE) {
                return;
            }
            if (request.status === 200) {
                onSuccess(request.responseXML);
            }
            else if (onError) {
                onError("failed with: " + request.status);
            }
        };
        request.send();
    };
    return XHRRequestHandler;
}());
exports.XHRRequestHandler = XHRRequestHandler;
